import { Dispatch, Reducer } from "redux";
import { GET_APP_STAGE } from "../actions/appStageActions";
import { getAppStage } from "../services/appStageService";
export interface AppStageState {
    stage: string;
}

const initialState: AppStageState = { stage: "" };

export const appStageReducer: Reducer<AppStageState> = (
    state: AppStageState = initialState,
    action: any
): AppStageState => {
    switch (action.type) {
        case GET_APP_STAGE:
            return action.payload;
        default:
            return state;
    }
};

export async function fetchAppStage(dispatch: Dispatch) {
    const res = await getAppStage();
    dispatch({ type: "GET_APP_STAGE", payload: res });
}
